import { Component } from '@angular/core'

@Component({
  selector: 'flo-category-list-skeleton',
  templateUrl: './category-list-skeleton.component.html',
  styleUrls: ['./category-list-skeleton.component.scss']
})
export class CategoryListSkeletonComponent {}
